/**
 * usePersistedFlag - a boolean that survives navigation and reloads (per
 * browser profile). Bill 2026-09-11, live smoke test: "you blanked out the
 * Show all checkbox" - the pilot toggles were plain useState, so leaving the
 * page and coming back reset them and the claimed applications vanished.
 * localStorage can be absent or throw inside the Teams webview; every access
 * is guarded and the hook degrades to plain state.
 */
import { useCallback, useState } from 'react';

export function usePersistedFlag(key: string, initial = false): [boolean, (v: boolean) => void] {
  const storageKey = `rop.flag.${key}`;
  const [value, setValue] = useState<boolean>(() => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw === null ? initial : raw === '1';
    } catch {
      return initial;
    }
  });
  const set = useCallback((v: boolean) => {
    setValue(v);
    try { window.localStorage.setItem(storageKey, v ? '1' : '0'); } catch { /* ignore */ }
  }, [storageKey]);
  return [value, set];
}
